import tw from 'tailwind-styled-components';
import styled from 'styled-components';

interface IContainerProps {
  banner: boolean;
}

export const Container = tw.div<IContainerProps>`
  ${(p: any) => (p.banner ? 'mb-16 relative' : 'mt-10 md:mt-14 mb-16')}
`;

export const CenterBlock = tw.div`
  flex
  flex-wrap
  justify-center
`;

export const Tags = tw(CenterBlock)`
  mx-5
  md:mb-3
`;

export const InfoBlock = tw(CenterBlock)`
  align-center
  md:mb-8
  items-center
`;

export const ShareBlock = tw(CenterBlock)`
  align-center
  my-8
  items-center
`;

export const DecoratedLine = tw.div`
  h-px
  flex-grow
  bg-brown
  md:mr-5
  hidden
  mmd:block
`;

export const InfoText = tw.span`
  inline-block
  pl-1
`;

export const InnerBannerContainer = styled.div<{ backgroundImg: string }>`
  background-image: url(${(p) => p.backgroundImg});
  background-size: cover;
`;

export const ImageFirst = tw.div`
  absolute
  right-0
  sm:h-auto
  sm:w-36
  md:w-1/3
  md:h-auto
  sm:-mt-12
  md:mr-13N
  md:mt-13N
`;

export const ImageSecond = tw.div`
  absolute
  sm:h-auto
  sm:w-36
  md:w-1/4
  md:h-auto
  -bottom-8
  md:-left-10
  sm:-left-6
`;

export const DownArrowWrapper = tw.div`
  md:-mt-48
  sm:-mt-22
  md:mb-16
  mb-2.5
`;

export const MainContainerStyle =
  'w-full md:rounded-b-HeroCurveBottom sm:rounded-b-heroInner bg-brown lg:h-heroCarousel md:h-heroCarouselM sm:h-heroCarousel md:mb-14 mb-5';

export const InnerContainerStyle =
  'lg:h-heroInner md:h-heroInnerM sm:h-heroInnerNoImage w-full lg:rounded-b-heroCurve md:rounded-b-heroCurveM sm:rounded-b-heroInnerS overflow-hidden z-0 flex flex-col justify-center';

export const Play = tw.div`
  w-10
  inline-block
  align-middle
  mr-2.5
`;

const CustomLinkStyle = styled.span`
  position: relative;

  &:after {
    content: '';
    position: absolute;
    display: block;
    width: 0%;
    left: 50%;
    bottom: 7px;
    border-bottom: 1px solid black;
    transition: all 0.5s;
    @media (min-width: 768px) {
      bottom: -2px;
    }
  }

  &:hover {
    &:after {
      width: 98%;
      left: 1%;
    }
  }
`;
export const StyledLink = tw(CustomLinkStyle)`
  md:inline-block
  cursor-pointer
`;

export const Dots = styled.span`
  width: 2px;
  height: 2px;
  background-color: #000;
  border-radius: 4px;
  margin: auto 10px;

  @media (min-width: 768px) {
    width: 4px;
    height: 4px;
  }
`;
